var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEvinovaLogo = function SvgEvinovaLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Evinova logo",
    width: 107,
    height: 92,
    viewBox: "0 0 107 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2107 20.4414C34.5678 20.4414 29.9922 25.0161 29.9922 30.6588C29.9922 36.3026 34.5678 40.8773 40.2107 40.8773H72.2117C77.8555 40.8773 82.4297 36.3026 82.4297 30.6588C82.4297 25.016 77.8555 20.4414 72.2117 20.4414H40.2107Z",
    fill: "url(#paint0_linear_1333_64423)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6599 35.4297C25.0166 35.4297 20.4414 40.0038 20.4414 45.6476C20.4414 51.2904 25.0166 55.8655 30.6599 55.8655H62.6605C68.3038 55.8655 72.8788 51.2904 72.8788 45.6476C72.8788 40.0038 68.3038 35.4297 62.6605 35.4297H30.6599Z",
    fill: "url(#paint1_linear_1333_64423)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1758 35.4297C32.8891 38.6699 36.2928 40.8789 40.2131 40.8789H71.6991C69.9856 37.6386 66.5825 35.4297 62.6617 35.4297H31.1758Z",
    fill: "url(#paint2_linear_1333_64423)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7224 50.4141C38.0791 50.4141 33.5039 54.9887 33.5039 60.631C33.5039 66.2748 38.0791 70.8499 43.7224 70.8499H75.723C81.3658 70.8499 85.9419 66.2748 85.9419 60.631C85.9419 54.9887 81.3658 50.4141 75.723 50.4141H43.7224Z",
    fill: "url(#paint3_linear_1333_64423)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7209 50.4141C39.8 50.4141 36.3969 52.6229 34.6836 55.8633H62.6606C66.5814 55.8633 69.9845 53.6538 71.6979 50.4141H43.7209Z",
    fill: "url(#paint4_linear_1333_64423)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1333_64423",
    x1: 29.9922,
    y1: 30.6593,
    x2: 82.4299,
    y2: 30.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB4A73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1333_64423",
    x1: 20.4414,
    y1: 45.6476,
    x2: 72.8787,
    y2: 45.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32EB9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F9EB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1333_64423",
    x1: 71.6989,
    y1: 38.1541,
    x2: 31.1759,
    y2: 38.1541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32EB9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1333_64423",
    x1: 33.504,
    y1: 60.6318,
    x2: 85.9418,
    y2: 60.6318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16D07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1333_64423",
    x1: 20.4415,
    y1: 53.1386,
    x2: 72.8788,
    y2: 53.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32EB9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEvinovaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "evinova-logo.ab3b581a163ffe1ec15bba0e8158ae54.svg";